/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2021 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { AppService } from '../app.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { MedicalcodesService } from '../../../../icemedx-lib/src/services/medicalcodes/medicalcodes.service';
import { BaseDocumentsComponent } from '../../../../icemedx-lib/src/components/basedocuments.component';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';

@Component({
  selector: 'app-pharmdocuments',
  templateUrl: './pharmdocuments.component.html',
  styleUrls: ['./pharmdocuments.component.scss'],
  providers: [AppService, IceNavService]
})
export class PharmdocumentsComponent extends BaseDocumentsComponent implements OnInit {
  constructor(appSvc: AppService,
    loginSvc: LoginService,
    messageSvc: MessageService,
    navSvc: IceNavService,
    domSvc: DomainService,
    medCodeSvc: MedicalcodesService,
    router: Router,
    pharmSvc: PharmacyService,) {
    super(appSvc, loginSvc, messageSvc, navSvc, domSvc, medCodeSvc, router, "pharmacies");
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }
}

